/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const needsAttention = 'Needs Attention';
export const mfgNameFieldLabel = 'Manufacturer Name';
export const mfgIdFieldLabel = 'ID';
export const contractsGridLabel = 'Contracts';
export const manufacturerGridLabel = 'Manufacturers';
export const nameLabel = 'Name';
export const corporationNameLabel = 'Corporation Name';
export const addressLine1Label = 'Address Line 1';
export const addressLine2Label = 'Address Line 2';
export const addressLine3Label = 'Address Line 3';
export const cityLabel = 'City';
export const stateLabel = 'State';
export const zipLabel = 'Zip';
export const zip4Label = 'Zip+4';
export const phoneNumberLabel = 'Phone Number';
export const extensionLabel = 'Extension';
export const faxNumberLabel = 'Fax Number';
export const manufacturersNameLabel = 'Manufacturer Name';
export const manufacturersIdLabel = 'Manufacturer ID';
export const emailLabel = 'Email Address';
export const clearNeedAttCode =
  "'Needs Attention Code' cleared. Click 'Save' to save changes.";
export const sourceContactRemovedMsg =
  "Relationship to Source Contact removed. Click 'Save' to make changes.";
export const copiedSourceContact =
  "Recopied Source Contact. Click 'Save' to changes.";
export const copiedNameDataSourceContact =
  "Copied Name Data From source Contact. Click 'Save' to make changes.";
export const copiedAddressDataSourceContact =
  "Copied Address Data From source Contact. Click 'Save' to make changes.";
export const noData = 'There is no data to copy from.';
export const noNeedsData = 'There is no data to clear Needs Attention code.';
export const noRelData =
  'There is no data to clear Remove Relationship to Source Contact.';
export const navigate = '/contactAnomalies';
export const SUCCESS_MAINTAIN = 'System successfully saved the information!';
